import { render, staticRenderFns } from "./ChatbotCreated.vue?vue&type=template&id=4d76360c&scoped=true"
import script from "./ChatbotCreated.vue?vue&type=script&lang=js"
export * from "./ChatbotCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76360c",
  null
  
)

export default component.exports